let baseUrl = '';
let routerMode = 'hash';
let baseImgPath;

if (process.env.NODE_ENV == 'development') {
    baseUrl = '/api';
    /*baseImgPath = '/img/';*/
}else{
    baseUrl = '';
    /*baseImgPath = '//elm.cangdu.org/img/';*/
}

export {
    baseUrl,
    routerMode,
    baseImgPath
}



// WEBPACK FOOTER //
// ./src/config/env.js